import { Box, Container, Grid } from "@mui/material";

import globalContext from '../../context/context'
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import WalletPrice from "../../utils/WalletPrice";
import { useTranslation } from "react-i18next";


function CartItems() {

    const { contextData: { cart: contextCart, currency, cartSum } } = useContext(globalContext);
    const { t } = useTranslation();

    const [cart, setCart] = useState(null);

    useEffect(() => {
        if (!contextCart && window.localStorage.getItem('successCartData')) {
            setCart(JSON.parse(window.localStorage.getItem('successCartData')));
        } else if (contextCart) {
            setCart(contextCart);
        }
    }, [contextCart, cart])

    return (
        <>
            <Container disableGutters sx={{ pt: 4 }}>
                <Box sx={{ border: '2px solid #f6c3ca', borderRadius: '10px' }}>
                    <Box sx={{ p: { xs: 2, md: 4 }, color: '#000', background: '#f6c3ca', border: '2px solid #f6c3ca', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                        <Box sx={{ pb: 1, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>{t("cart.walletFunds")}: <WalletPrice /></Box>
                        <Box sx={{ pt: 1, fontWeight: 900, fontSize: 16, color: '#000' }}>
                            {cart?.directionFrom?.departureTransfer && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionFrom?.departureTransfer?.quantity} x {cart?.directionFrom?.departureTransfer?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.departureTransfer?.priceInCurrency} {cart?.directionFrom?.departureTransfer?.currency}</Grid>
                            </Grid>}
                            {cart?.directionFrom?.arrivalTransfer && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionFrom?.arrivalTransfer?.quantity} x {cart?.directionFrom?.arrivalTransfer?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.arrivalTransfer?.priceInCurrency} {cart?.directionFrom?.arrivalTransfer?.currency}</Grid>
                            </Grid>}
                            {cart?.directionFrom?.departureLounge && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionFrom?.departureLounge?.quantity} x {cart?.directionFrom?.departureLounge?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.departureLounge?.priceInCurrency} {cart?.directionFrom?.departureLounge?.currency}</Grid>
                            </Grid>}
                            {cart?.directionFrom?.departureParking && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionFrom?.departureParking?.quantity} x {cart?.directionFrom?.departureParking?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.departureParking?.priceInCurrency} {cart?.directionFrom?.departureParking?.currency}</Grid>
                            </Grid>}

                            {cart?.directionTo?.departureTransfer && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionTo?.departureTransfer?.quantity} x {cart?.directionTo?.departureTransfer?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.departureTransfer?.priceInCurrency} {cart?.directionTo?.departureTransfer?.currency}</Grid>
                            </Grid>}
                            {cart?.directionTo?.arrivalTransfer && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionTo?.arrivalTransfer?.quantity} x {cart?.directionTo?.arrivalTransfer?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.arrivalTransfer?.priceInCurrency} {cart?.directionTo?.arrivalTransfer?.currency}</Grid>
                            </Grid>}
                            {cart?.directionTo?.departureLounge && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionTo?.departureLounge?.quantity} x {cart?.directionTo?.departureLounge?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.departureLounge?.priceInCurrency} {cart?.directionTo?.departureLounge?.currency}</Grid>
                            </Grid>}
                            {cart?.directionTo?.departureParking && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionTo?.departureParking?.quantity} x {cart?.directionTo?.departureParking?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.departureParking?.priceInCurrency} {cart?.directionTo?.departureParking?.currency}</Grid>
                            </Grid>}
                            {cart?.directionTo?.departureFastTrack && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionTo?.departureFastTrack?.quantity} x {cart?.directionTo?.departureFastTrack?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.departureFastTrack?.priceInCurrency} {cart?.directionTo?.departureFastTrack?.currency}</Grid>
                            </Grid>}
                            {cart?.directionFrom?.departureFastTrack && <Grid direction="row"
                                justifyContent="space-between"
                                sx={{ py: 0.5 }}
                                alignItems="center" container>
                                <Grid xs={8} item>{cart?.directionFrom?.departureFastTrack?.quantity} x {cart?.directionFrom?.departureFastTrack?.name}</Grid>
                                <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.departureFastTrack?.priceInCurrency} {cart?.directionFrom?.departureFastTrack?.currency}</Grid>
                            </Grid>}

                        </Box>
                    </Box>
                    <Box sx={{ px: { xs: 2, md: 4 }, py: 1, color: '#000' }}>
                        <Box sx={{ pt: 1, fontWeight: 900, fontSize: 16, color: '#000' }}>
                            <Grid direction="row"
                                justifyContent="space-between"
                                alignItems="top" container>
                                <Grid xs={7} item>
                                    {cartSum?.promotionInCurrency ? <>
                                        <small style={{ fontWeight: 'normal' }}>{t("cart.promotionDiscount")}</small>
                                        <br />
                                        {t("cart.totalPaid")}
                                    </> : <>
                                        {t("cart.totalPaid")}
                                    </>}
                                    {!!cartSum?.transactionFeeInCurrency && <>
                                        <br />
                                        <small style={{ fontWeight: 'normal' }}><strong>{cartSum?.transactionFeeInCurrency} {currency}</strong> {t("cart.transactionFee")}</small>
                                    </>}
                                </Grid>
                                <Grid xs={5} style={{ textAlign: 'right' }} item>

                                    {cartSum?.promotionInCurrency ? <>
                                        <small style={{ fontWeight: 'bold' }}>{cartSum?.promotionInCurrency} {currency}</small>
                                        <br />
                                        <small style={{ textDecoration: 'line-through', fontWeight: 'normal' }}>{cartSum?.priceInCurrency} {currency}</small> {cartSum?.priceWithPromotionAndTransactionFeeInCurrency} {currency}
                                    </> : <>
                                        {cartSum?.priceWithPromotionAndTransactionFeeInCurrency} {currency}
                                    </>}
                                    <br />
                                    <small style={{ fontWeight: 'normal' }}>{t("cart.vatIncl")}</small>
                                </Grid>
                            </Grid>

                        </Box>
                    </Box>
                </Box>
            </Container>

        </>
    );
}

export default CartItems;
